import React, { Component } from "react";
import {
    View,
    TouchableOpacity,
    Image,
    Dimensions,
    Pressable,
    ScrollView
} from "react-native";

import { White, WHITE } from "react-native-material-color";

// import ActionSheet from 'react-native-actionsheet';

import * as Styles from "../utils/Styles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import Header from "../components/Header";
import Text from "../components/Text";
let height = Dimensions.get("window").height;
let width = Commons.getWidth();
let marginTop = 0;
let styles = {};
let brandPos = 1;
let brandFlag = 1;
let isMobile = false;
const arrowRight = require("../images/arrowright.png");
const arrowRight2 = require("../images/arrowright2.png");
const chevron = require("../images/chevron.png");
const chevron2 = require("../images/chevron2.png");
const jo1 = require("../images/home/jo1.png");
const jo2 = require("../images/home/jo2.png");
const jo3 = require("../images/home/jo3.png");
const jo4 = require("../images/home/jo4.png");
const jo5 = require("../images/home/jo5.png");
const joImgs = [jo1, jo2, jo3, jo4, jo5]
const brandsImageSize = {}
const imgSandoz = require("../images/Products/Sandoz Logo(2).jpg");
const imgBoehringer = require("../images/Products/boehringer.png");
const imgServier = require("../images/Products/Servier Logo(1).jpg");
const imgGeltec = require("../images/Products/geltec.png");
const imgBayer = require("../images/Products/Bayer Logo.jpg");
const imgNovartis = require("../images/Products/Novartis Logo(1).jpg");
const imgMolnlycke = require("../images/Products/Molnlycke Logo(1).jpg");
const imgKimberly = require("../images/Products/kimberly.png");
const imgLoreal = require("../images/Products/Loreal Paris Logo.jpg");
const img3M = require("../images/Products/3M Logo.jpg");
const imgFlexitol = require("../images/Products/flexitol.png");
const imgNexcare = require("../images/Products/nexcare.png");
const imgLarocheposay = require("../images/Products/laroch.png");
const imgVichy = require("../images/Products/Group.jpg");
const imgFuturo = require("../images/Products/futuro.png");
const imgGarnier = require("../images/Products/garnier.png");
const imgMaybelline = require("../images/Products/Layer 1.jpg");
const imgDelass = require("../images/Products/delass.png");
const imgSanofi = require("../images/Products/sanofi.png");
const imgCera = require("../images/Products/cera.png");
const imgBepan = require("../images/Products/bepan.png");
const imgPriorin = require("../images/Products/priorin.png");
const imgHuggies = require("../images/Products/huggies.png");
const imgDepend = require("../images/Products/depend.png");
const imgDryNites = require("../images/Products/dryNites.png");
const imgJustForMen = require("../images/Products/justForMen.png");
const imgVagisil = require("../images/Products/vagisil.png");
const imgKotex = require("../images/Products/kotex.png");
const imgIsDora = require("../images/Products/isDora.png");

class Products extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isScrolled: false,
            isVideoPlaying: false,
            brands: [],
            joImgPos: 0,
            hideScrollTopButton: true
        };
    }
    Pressables = {};

    async componentDidMount() {
    }


    renderPressableButton = (componentRef, text, onPress) => {
        const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
        return (
            <Pressable
                ref={el => (this.Pressables[componentRef] = el)}
                onHoverIn={() => this.setState({ hoveredComponent: this.Pressables[componentRef] })}
                onHoverOut={() => this.setState({ hoveredComponent: undefined })} >
                <TouchableOpacity onPress={onPress} style={isHovered ? Styles.ButtonStyleHovered : Styles.ButtonStyle}>
                    <Text style={isHovered ? Styles.ButtonTextStyleHovered : Styles.ButtonTextStyle}>{text}</Text>
                </TouchableOpacity>
            </Pressable>
        )
    }

    renderPressableLink = (text, textStyle, onPress) => {
        const componentRef = text;
        const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
        const color = isHovered ? '#52c0ee' : '#3B627F';
        return (
            <Pressable
                ref={el => (this.Pressables[componentRef] = el)}
                onHoverIn={() => this.setState({ hoveredComponent: this.Pressables[componentRef] })}
                onHoverOut={() => this.setState({ hoveredComponent: undefined })} >
                <TouchableOpacity onPress={onPress} style={{
                    flexDirection: "row", alignSelf: "flex-start", alignItems: "center", justifyContent: "center", gap: 8,
                    border: '1.5px solid transparent',
                    borderBottomColor: color
                }}>
                    <Text style={[Styles.TextStyle2, isHovered && { color }, textStyle, {
                        fontSize: 15
                    }]}>{text}</Text>
                    <Image source={isHovered ? arrowRight2 : arrowRight} style={{ height: 12, width: 14, marginBottom: -2 }} resizeMode="contain" />
                </TouchableOpacity>
            </Pressable>
        )
    }

    renderMobile() {
        return (
            <View style={styles.container}>
                <Header
                    title={STRINGS.company_name}
                    leftView={Styles.drawerButtonDark(this.props.navigation)}
                    light={true}
                    navigation={this.props.navigation}
                    hideHeader={this.state.hideHeader}
                    hideScrollTopButton={this.state.hideScrollTopButton}
                    self={this}
                    selectedTab={"Products"}
                />
                <ScrollView
                    ref={ref => this.mainScrollView = ref}
                    scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}
                    style={{ gap: 50 }}>
                    {Commons.loadFonts(this)}
                    {this.renderPart1Mobile()}
                    {this.renderPart2Mobile()}
                    {this.renderPart3Mobile()}
                    {this.renderPart4Mobile()}
                    {this.renderPart5Mobile()}
                    {/* {this.renderPart6Mobile()} */}

                    {Commons.renderFooter({}, this)}
                </ScrollView >

            </View >
        );
    }


    render() {
        Commons.resizeHandle(window, this, () => {
            width = this.width;
            height = this.height;
        });
        width = Dimensions.get("window").width;
        isMobile = Commons.isMobile();
        if (isMobile) {
            styles = this.styles();
            return this.renderMobile();
        }
        width = Commons.getWidth();
        styles = this.styles();
        marginTop = 300;
        return (
            <View style={styles.container}>
                <Header
                    title={STRINGS.company_name}
                    leftView={Styles.drawerButtonDark(this.props.navigation)}
                    light={true}
                    navigation={this.props.navigation}
                    hideHeader={this.state.hideHeader}
                    hideScrollTopButton={this.state.hideScrollTopButton}
                    self={this}
                    selectedTab={"Products"}
                />
                <ScrollView
                    ref={ref => this.mainScrollView = ref}
                    scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}
                    style={{ gap: 84 }}>
                    {Commons.loadFonts(this)}
                    {this.renderPart1()}
                    {this.renderPart2()}
                    {this.renderPart3()}
                    {this.renderPart4()}
                    {this.renderPart5()}
                    {this.renderPart6()}

                    {Commons.renderFooter({}, this)}
                </ScrollView >

            </View >
        );
    }

    renderPart1 = () => {
        return (<View style={{
            paddingTop: 200,
            paddingLeft: 164,
            flexDirection: 'column',
            gap: 30,

        }}>
            <View style={{ flexDirection: 'column', gap: 1 }}>
                {/* <Text style={Styles.TextStyle2}>Portfolio</Text> */}
                <Text style={Styles.TextStyle3}>Jordan Drugstore Co. Portfolio</Text>
            </View>

            <Text style={[Styles.TextStyle2, { color: Styles.appColor3 }]}>
                We offer a comprehensive suite of services and solutions designed to
                {'\n'}optimize the healthcare supply chain, ensuring quality products reach those
                {'\n'}who need them efficiently and reliably.
            </Text>
            <View style={{ height: 100 }}></View>
        </View>
        )
    }

    renderPart1Mobile = () => {
        return (
            <View style={{
                paddingTop: 200,
                paddingHorizontal: 20,
                flexDirection: 'column',
                gap: 30,
                backgroundColor: WHITE

            }}>
                <Text style={Styles.TextStyle3}>Jordan Drugstore Co. Portfolio</Text>

                <Text style={[Styles.TextStyle2, { color: Styles.appColor3 }]}>
                    We offer a comprehensive suite of services and solutions
                    designed to optimize the healthcare supply chain,
                    ensuring quality products reach those who need them
                    efficiently and reliably.
                </Text>
                <View style={{ height: 50 }}></View>


            </View>)
    }

    renderPart2 = () => {
        return (<View style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 30,
            paddingLeft: 164,
        }}>
            <Text style={[Styles.TextStyle3]}>Pharmaceuticals Division</Text>
            <Text style={[Styles.TextStyle2, { color: Styles.appColor3 }]}>
                Our Jordan Drugstore Co. Pharmaceuticals Division stands as a pillar of our commitment to
                {'\n'}advancing healthcare. We proudly partner with renowned pharmaceutical manufacturers and
                {'\n'}brands to ensure that essential medications reach those in need across Jordan. Our dedication to
                {'\n'}quality and excellence has led to trusted colaborations that benefit both our partners and the
                {'\n'}communities we serve.
            </Text>
            <View style={{ height: 10 }}></View>
        </View>
        )
    }

    renderPart2Mobile = () => {
        return (<View style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 30,
            paddingHorizontal: 20,
            backgroundColor: WHITE
        }}>
            <Text style={[Styles.TextStyle3]}>Pharmaceuticals Division</Text>
            <Text style={[Styles.TextStyle2, { color: Styles.appColor3, }]}>
                Our Jordan Drugstore Co. Pharmaceuticals Division
                stands as a pillar of our commitment to advancing
                healthcare. We proudly partner with renowned
                pharmaceutical manufacturers and brands to
                ensure that essential medications reach those
                in need across Jordan. Our dedication to quality
                and excellence has led to trusted colaborations
                that benefit both our partners and the
                communities we serve.
            </Text>
            <View style={{ height: 50 }}></View>
        </View>
        )
    }

    renderPart3 = () => {
        return (
            <View style={{
                display: 'flex',
                width: 891,
                alignItems: 'flex-start',
                alignContent: 'flex-start',
                gap: 30,
                flexWrap: 'wrap',
                flexDirection: 'column',
                paddingLeft: 169,
                marginTop: 30
            }}>

                <View style={{ flexDirection: 'row', gap: 30 }}>
                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgNovartis} style={{ height: 27.017, width: 165, resizeMode: 'contain' }}></Image>
                    </View>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgBoehringer} style={{ height: 44, width: 142.511, resizeMode: 'contain' }}></Image>
                    </View>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgBayer} style={{ height: 66, width: 66, resizeMode: 'contain' }}></Image>
                    </View>
                </View>

                <View style={{ flexDirection: 'row', gap: 30 }}>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgServier} style={{ height: 28.019, width: 141, resizeMode: 'contain' }}></Image>
                    </View>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgDelass} style={{ height: 77.349, width: 73, resizeMode: 'contain' }}></Image>
                    </View>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgSandoz} style={{ height: 18.877, width: 139.831, resizeMode: 'contain' }}></Image>
                    </View>
                </View>

                <View style={{ flexDirection: 'row', gap: 30 }}>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgMolnlycke} style={{ height: 50.88, width: 106.462, resizeMode: 'contain' }}></Image>
                    </View>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgGeltec} style={{ height: 34.915, width: 89, resizeMode: 'contain' }}></Image>
                    </View>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgSanofi} style={{ height: 26, width: 101.217, resizeMode: 'contain' }}></Image>
                    </View>
                </View>


            </View>
        )
    }

    renderPart3Mobile = () => {
        const scale = width > 420 ? 1 : width / 420;
        return (<View style={{
            alignItems: 'center',
            flexDirection: 'column',
            gap: 30,
            width: width > 420 ? 420 : width
        }}>
            <View style={{ flexDirection: 'row', gap: 20.55 }}>
                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgNovartis} style={{ height: 18.505 * scale, width: 113.013 * scale, resizeMode: 'contain' }}></Image>
                </View>

                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgBoehringer} style={{ height: 30.137 * scale, width: 97.61 * scale, resizeMode: 'contain' }}></Image>

                </View>
            </View>

            <View style={{ flexDirection: 'row', gap: 20.55 }}>
                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgBayer} style={{ height: 45.205 * scale, width: 45.205 * scale, resizeMode: 'contain' }}></Image>
                </View>
                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgServier} style={{ height: 19.191 * scale, width: 96.576 * scale, resizeMode: 'contain' }}></Image>
                </View>
            </View>


            <View style={{ flexDirection: 'row', gap: 20.55 }}>
                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgDelass} style={{ height: 52.979 * scale, width: 50 * scale, resizeMode: 'contain' }}></Image>
                </View>

                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgSandoz} style={{ height: 12.93 * scale, width: 95.774 * scale, resizeMode: 'contain' }}></Image>
                </View>
            </View>

            <View style={{ flexDirection: 'row', gap: 20.55 }}>
                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgMolnlycke} style={{ height: 34.85 * scale, width: 72.919 * scale, resizeMode: 'contain' }}></Image>
                </View>

                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgGeltec} style={{ height: 23.915 * scale, width: 60.959 * scale, resizeMode: 'contain' }}></Image>
                </View>
            </View>

            <View style={{ flexDirection: 'row', gap: 20.55 }}>
                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgSanofi} style={{ height: 17.808 * scale, width: 69.327 * scale, resizeMode: 'contain' }}></Image>
                </View>
                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0 }}>
                </View>
            </View>


        </View>)
    }

    renderPart4 = () => {
        return (<View style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 30,
            width,
            paddingLeft: 164,
            marginTop: 120
        }}>
            <Text style={[Styles.TextStyle3]}>Parapharmaceutical Division</Text>
            <Text style={[Styles.TextStyle2, { color: Styles.appColor3 }]}>
                In our Jordan Drugstore Co. Consumer Division, we provide a wide range of
                {'\n'}consumer healthcare products, from over-the-counter medications to personal
                {'\n'}care essentials. Our partnerships with leading consumer brands enable us to
                {'\n'}empower individuals to take control of their health, beauty and well-being.
            </Text>
        </View>
        )
    }

    renderPart4Mobile = () => {
        return (<View style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 24,
            width,
            paddingHorizontal: 20,
            marginTop: 120
        }}>
            <Text style={[Styles.TextStyle3]}>Parapharmaceutical Division</Text>
            <Text style={[Styles.TextStyle2, { color: Styles.appColor3 }]}>
                In our Jordan Drugstore Co. Consumer Division, we
                provide a wide range of consumer healthcare
                products, from over-the-counter medications
                to personal care essentials. Our partnerships
                with leading consumer brands enable us to
                empower individuals to take control of their
                health, beauty and well-being.
            </Text>
        </View>
        )
    }

    renderPart5 = () => {

        return (
            <View style={{
                display: 'flex',
                width: 891,
                alignItems: 'flex-start',
                alignContent: 'flex-start',
                gap: 30,
                flexWrap: 'wrap',
                flexDirection: 'column',
                paddingLeft: 169,
                marginTop: 80
            }}>

                <View style={{ flexDirection: 'row', gap: 30 }}>
                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgLarocheposay} style={{ height: 58, width: 263.518, resizeMode: 'contain', flexShrink: 0 }}></Image>
                    </View>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgVichy} style={{ height: 30, width: 110.539, resizeMode: 'contain', flexShrink: 0 }}></Image>
                    </View>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgCera} style={{ height: 50, width: 118.793, resizeMode: 'contain', flexShrink: 0 }}></Image>
                    </View>
                </View>

                <View style={{ flexDirection: 'row', gap: 30 }}>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgLoreal} style={{ height: 29.052, width: 108.999, resizeMode: 'contain', flexShrink: 0 }}></Image>
                    </View>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgGarnier} style={{ height: 74, width: 142.511, resizeMode: 'contain', flexShrink: 0 }}></Image>
                    </View>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgMaybelline} style={{ height: 44, width: 163.061, resizeMode: 'contain', flexShrink: 0 }}></Image>
                    </View>
                </View>

                <View style={{ flexDirection: 'row', gap: 30 }}>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgBepan} style={{ height: 24.78, width: 105, resizeMode: 'contain', flexShrink: 0 }}></Image>
                    </View>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgPriorin} style={{ height: 83, width: 128, resizeMode: 'contain', flexShrink: 0 }}></Image>
                    </View>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgHuggies} style={{ height: 71.438, width: 127, resizeMode: 'contain', flexShrink: 0 }}></Image>
                    </View>
                </View>

                <View style={{ flexDirection: 'row', gap: 30 }}>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgKotex} style={{ height: 22, width: 100.213, resizeMode: 'contain', flexShrink: 0 }}></Image>
                    </View>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgDepend} style={{ height: 112, width: 112, resizeMode: 'contain', flexShrink: 0 }}></Image>
                    </View>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgDryNites} style={{ height: 32, width: 106.146, resizeMode: 'contain', flexShrink: 0 }}></Image>
                    </View>
                </View>

                <View style={{ flexDirection: 'row', gap: 30 }}>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgFlexitol} style={{ height: 67.418, width: 129.001, resizeMode: 'contain', flexShrink: 0 }}></Image>
                    </View>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgFuturo} style={{ height: 51.79, width: 151, resizeMode: 'contain', flexShrink: 0, marginTop: 15, marginRight: 13 }}></Image>
                    </View>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgNexcare} style={{ height: 44, width: 117.595, resizeMode: 'contain', flexShrink: 0 }}></Image>
                    </View>
                </View>

                <View style={{ flexDirection: 'row', gap: 30 }}>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgIsDora} style={{ height: 22, width: 117.85, resizeMode: 'contain', flexShrink: 0 }}></Image>
                    </View>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgJustForMen} style={{ height: 38, width: 95, resizeMode: 'contain', flexShrink: 0 }}></Image>
                    </View>

                    <View style={{ height: 112, width: 277, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 2, borderColor: 'lightgrey' }}>
                        <Image source={imgVagisil} style={{ height: 40, width: 136.703, resizeMode: 'contain', flexShrink: 0 }}></Image>
                    </View>
                </View>


            </View>

        )
    }

    renderPart5Mobile = () => {
        const scale = width > 420 ? 1 : width / 420;
        return (<View style={{
            alignItems: 'center',
            flexDirection: 'column',
            gap: 30,
            width: width > 420 ? 420 : width,
            marginTop: 100
        }}>
            <View style={{ flexDirection: 'row', gap: 20.55 }}>
                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgLarocheposay} style={{ height: 26.028 * scale, width: 143 * scale, resizeMode: 'contain' }}></Image>
                </View>

                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgVichy} style={{ height: 20.548 * scale, width: 75.713 * scale, resizeMode: 'contain' }}></Image>
                </View>
            </View>

            <View style={{ flexDirection: 'row', gap: 20.55 }}>
                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgCera} style={{ height: 34.247 * scale, width: 81.367 * scale, resizeMode: 'contain' }}></Image>
                </View>
                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgLoreal} style={{ height: 19.899 * scale, width: 74.659 * scale, resizeMode: 'contain' }}></Image>
                </View>
            </View>


            <View style={{ flexDirection: 'row', gap: 20.55 }}>
                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgGarnier} style={{ height: 20.549 * scale, width: 86.231 * scale, resizeMode: 'contain' }}></Image>
                </View>

                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgMaybelline} style={{ height: 30.138 * scale, width: 111.688 * scale, resizeMode: 'contain' }}></Image>
                </View>
            </View>

            <View style={{ flexDirection: 'row', gap: 20.55 }}>
                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgBepan} style={{ height: 18.585 * scale, width: 78.75 * scale, resizeMode: 'contain' }}></Image>
                </View>

                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgPriorin} style={{ height: 68.5 * scale, width: 96, resizeMode: 'contain' }}></Image>
                </View>
            </View>

            <View style={{ flexDirection: 'row', gap: 20.55 }}>
                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgHuggies} style={{ height: 48.931 * scale, width: 86.988 * scale, resizeMode: 'contain' }}></Image>
                </View>

                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgKotex} style={{ height: 15.069 * scale, width: 68.64 * scale, resizeMode: 'contain' }}></Image>
                </View>
            </View>

            <View style={{ flexDirection: 'row', gap: 20.55 }}>
                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgDepend} style={{ height: 76.714 * scale, width: 76.714 * scale, resizeMode: 'contain' }}></Image>
                </View>

                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgDryNites} style={{ height: 21.918 * scale, width: 72.704 * scale, resizeMode: 'contain' }}></Image>
                </View>
            </View>

            <View style={{ flexDirection: 'row', gap: 20.55 }}>
                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgFlexitol} style={{ height: 46.178 * scale, width: 88.358 * scale, resizeMode: 'contain' }}></Image>
                </View>

                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgFuturo} style={{ height: 33.915 * scale, width: 103.427 * scale, resizeMode: 'contain', marginTop: 8, marginRight: 3 }}></Image>
                </View>
            </View>

            <View style={{ flexDirection: 'row', gap: 20.55 }}>
                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgNexcare} style={{ height: 30.138 * scale, width: 80.546 * scale, resizeMode: 'contain' }}></Image>
                </View>

                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgIsDora} style={{ height: 15.069 * scale, width: 80.069 * scale, resizeMode: 'contain' }}></Image>
                </View>
            </View>

            <View style={{ flexDirection: 'row', gap: 20.55 }}>
                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgJustForMen} style={{ height: 26.028 * scale, width: 65.07 * scale, resizeMode: 'contain' }}></Image>
                </View>

                <View style={{ height: 76.712 * scale, width: 173.726 * scale, display: 'flex', padding: 8, justifyContent: 'center', alignItems: 'center', gap: 8, flexShrink: 0, borderWidth: 0.68, borderColor: 'lightgrey' }}>
                    <Image source={imgVagisil} style={{ height: 27.398 * scale, width: 93.634 * scale, resizeMode: 'contain' }}></Image>
                </View>
            </View>
            <View style={{ height: 50 }}></View>


        </View>)
    }

    renderPart6 = () => {
        return (<View style={{ marginTop: 30 }}>

        </View>

        )
    }



    onBrandScroll = (e) => {
        const endReached =
            parseInt(e.nativeEvent.contentOffset.x) +
            parseInt(e.nativeEvent.layoutMeasurement.width) -
            parseInt(e.nativeEvent.contentSize.width) ==
            0;
        const startReached = e.nativeEvent.contentOffset.x == 0;
        if (endReached) {
            brandFlag = -1;
            // this.brandsView.scrollTo({ animated: true, x: 0 });
        } else if (startReached) {
            brandFlag = 1;
        }
    };

    styles = () => ({
        container: {
            flex: 1,
            width: width,
            paddingVertical: 0,
            paddingHorizontal: 164,
            alignItems: "center",
            gap: 100,
            backgroundColor: WHITE
        },
        image: {
            flex: 1,
            resizeMode: 'contain',
            justifyContent: 'center',
            width,
            height: width * 0.46,
        }
    });
}



export default Products;